import * as DesignerFunctions from './utilities/DesignerFunctions';
import * as CoreFns from './utilities/CoreFns';
import * as StyleFunctions from './utilities/StyleFunctions';
import * as ResponsiveFns from './utilities/ResponsiveFns';

function getColorSet(palette, colorCombo){
  var colorSet = false;
  palette.forEach((aColor, index)=>{
    var isThis = (aColor.v[0].v === colorCombo);
    if (isThis){
      colorSet = aColor;
    }
  })
  return colorSet;
}
export function createNull(){
  	var cust = {};
  	for (var i = 1; i < 12; i++){
    	cust[i+''] = false;
  	}
	return cust;	
}

export function getColorComponents(isShowingCustom, customColorRecord, palette, colorCombo){

  var colorSet = getColorSet(palette, colorCombo);

  var p = modCats();

  var components = {};
  if (isShowingCustom){
    p.forEach((aP, index2)=>{
      if (aP.i === 'buttonColor'){
        for (var i1 = 8; i1 < 12; i1++){
          var thisPP1 = customColorRecord[i1+''];
          if (thisPP1){
            var inside1 = {};
            inside1[aP.i] = {t: 'raw', v: thisPP1};
            components[aP.i + '_' + (i1-7)] = inside1;            
          }
        }
      }else{
        for (var i = 1; i < 8; i++){
          var thisPP = customColorRecord[i+''];
          if (thisPP){
            var inside = {};
            inside[aP.i] = {t: 'raw', v: thisPP};
            components[aP.i + '_' + i] = inside;            
          }
        }        
      }
    });
  }else{
    if (colorSet){
      p.forEach((aP, index2)=>{
        var small = 1;
        var large = 9;
        if (aP.i === 'buttonColor'){
          small = 8;
          large = 12;
        }

        colorSet.v.filter((aColorSet, index)=>{
          return +index > small && +index < large;          
        }).forEach((aColorSet, index)=>{
          var thisP = +index + 1;
          var inside = {};
          if (aColorSet.v){
            inside[aP.i] = {t: 'raw', v: aColorSet.v};
            components[aP.i + '_' + thisP] = inside;            
          }
        })
      });
    }
  }  
  return components;
}

function modCats(){
	return [{i:'backgroundColor'}, {i:'backgroundColor2'}, {i:'iconColor'}, {i:'color'}, {i:'legendColor'}, {i:'buttonColor'}, {i:'outlineColor'}, {i:'tickColor'}, {i:'hoverColor'}, {i:'borderColor'}, {i:'strokeColor'}, {i:'yColor'}, {i:'xColor'}];
}

export function actionMods(currentList, info, itemType, chains, changeTab){

	var toAdd = findIssues(currentList, info, itemType, chains, changeTab);

	return toAdd.map((aPath, index)=>{
		var originSet = aPath.originSet;
		var nameSet = nameThePath(currentList, originSet);
		return {before:originSet.originPath, ocType:originSet.ocType, name:nameSet.name, path:aPath.path, n:aPath.n, initiatingType:nameSet.a, screenPath:originSet.screenPath};

	})
}

export function findIssues(currentList, info, itemType, chains, changeTab){
	var toAdd = [];
	if (currentList.oc){
		var p1 = searchThroughOCSet(currentList.oc, [], 'overall', [], itemType, info, currentList, chains, changeTab);
		toAdd = toAdd.concat(p1);
	}

	if (itemType === 'placeholder' || itemType === 'selectNew' || itemType === 'amendNew'){
		if (currentList.s){
			var p4 = goThroughStyles([], [], currentList, 'overall', itemType, info, currentList);
			toAdd = toAdd.concat(p4);
		}
	}

	if (currentList.fo && currentList.fo.on){
		var p2 = doFooter(['fo'], currentList.fo, itemType, info, currentList, chains, changeTab);
		toAdd = toAdd.concat(p2);		
	}

	var toChecks = ['fe', 'pu'];
	toChecks.forEach((aSSet, index0)=>{
		var fe = currentList[aSSet];
		if (fe){
			var feKeys = Object.keys(fe);
			feKeys.forEach((anFEKey, index)=>{
				var thisFE = fe[anFEKey];
				var add = doAPage([aSSet, anFEKey], thisFE, itemType, info, currentList, chains, changeTab);
				toAdd = toAdd.concat(add);
			})		
			
		}
	})
	return toAdd;	
}

export function doAPage(pagePath, page, itemType, info, currentList, chains, changeTab){
	var toAdd = [];
	var nvAdd = doANavBar(pagePath.concat(['nv']), page.nv, itemType, info, currentList, chains, changeTab);
	toAdd = toAdd.concat(nvAdd);

	var panels = page._s;
	var panelKeys = Object.keys(panels);
	panelKeys.forEach((aPanelKey, index2)=>{
		var thisPanel = panels[aPanelKey];
		var panelPath = pagePath.concat(['_s', aPanelKey]);
		var pAdd = doAPanel(panelPath, thisPanel, itemType, info, currentList, chains, changeTab);
		toAdd = toAdd.concat(pAdd);
	})
	return toAdd;

}

export function doFooter(footerPath, footer, itemType, info, currentList, chains, changeTab){
	var toAdd = [];
	if (itemType === 'placeholder' || itemType === 'selectNew' || itemType === 'amendNew'){
		if (footer.s){
			var p4 = goThroughStyles(footerPath, footerPath, footer, 'screen', itemType, info, currentList);
			toAdd = toAdd.concat(p4);
		}
	}

	var b = trudgeDown(footerPath, footer, 'k', itemType, info, currentList, chains, changeTab);
	return b.concat(toAdd);
}

export function doAPanel(panelPath, thisPanel, itemType, info, currentList, chains, changeTab){
	var toAdd = [];
	var p1 = trudgeDown(panelPath, thisPanel, 'al', itemType, info, currentList, chains, changeTab);
	toAdd = toAdd.concat(p1);
	var p2 = trudgeDown(panelPath, thisPanel, 'i', itemType, info, currentList, chains, changeTab);
	toAdd = toAdd.concat(p2);
	var p3 = trudgeDown(panelPath, thisPanel, 'k', itemType, info, currentList, chains, changeTab);
	toAdd = toAdd.concat(p3);

	if (itemType === 'placeholder' || itemType === 'selectNew' || itemType === 'amendNew'){
		if (thisPanel.s){
			var p5 = goThroughStyles(panelPath, panelPath, thisPanel, 'screen', itemType, info, currentList);
			toAdd = toAdd.concat(p5);
		}
	}
	return toAdd;
}

export function doANavBar(navPath, nv, itemType, info, currentList, chains, changeTab){
	var toAdd = [];
	if (nv){
		if (nv.on || itemType === 'elementUploadChecks' || itemType === 'elementDownloadMods' || itemType === 'scUsage' || itemType === 'selectNew' || itemType === 'amendNew'){
			if (nv.on === 1){
			}else if (nv.on){
				navPath = ['cn', nv.on, 'nv'];
				nv = CoreFns.goDownPath(currentList, navPath);
			}


			if (itemType === 'selectNew' || itemType === 'amendNew'){
				if (nv.s){
					var p4 = goThroughStyles(navPath, navPath, nv, 'NAV', itemType, info, currentList);
					toAdd = toAdd.concat(p4);
				}					
			}

			if (nv.on){
				var p0 = trudgeDown(navPath, nv, 'i', itemType, info, currentList, chains, changeTab);
				toAdd = toAdd.concat(p0);
				if (nv.s && nv.s.navbarCluster){
					var p1 = trudgeDown(navPath, nv, 'ic', itemType, info, currentList, chains, changeTab);
					var p2 = trudgeDown(navPath, nv, 'ir', itemType, info, currentList, chains, changeTab);
					toAdd = toAdd.concat(p1).concat(p2);
				}

			}
		}		
	}
	return toAdd;
}

function trudgeDown(panelPath, thisPanel, subfield, itemType, info, currentList, chains, changeTab){
	var type = 'item';
	if (subfield === 'al'){
		type = 'alert';
	}else if (subfield === 'd'){
		type = 'LINEDATA';
	}
	
	var toAdd = [];
	var alerts = thisPanel[subfield];
	if (alerts){
		var alertKeys = Object.keys(alerts);
		alertKeys.forEach((anAlertKey, index3)=>{
			var thisAlert = alerts[anAlertKey];
			var screenPath = panelPath.concat([subfield, anAlertKey]);
			var toAdd1 = goThroughAnItem(screenPath, thisAlert, type, itemType, info, currentList, chains, changeTab);
			toAdd = toAdd.concat(toAdd1);
		})		
	}
	return toAdd;
}


export function goThroughAnItem(screenPath, thisAlert, type, itemType, info, currentList, chains, changeTab){
	var toAdd = [];
	var p1 = searchThroughOCSet(thisAlert.oc, screenPath, type, screenPath, itemType, info, currentList, chains, changeTab);
	toAdd = toAdd.concat(p1);
	if (thisAlert.i){
		var p2 = trudgeDown(screenPath, thisAlert, 'i', itemType, info, currentList, chains, changeTab);
		toAdd = toAdd.concat(p2);
	}
	if (itemType === 'selectNew' || itemType === 'amendNew'){
		if (thisAlert.t === 'LINECHART' || thisAlert.t === 'BARCHART' || thisAlert.t === 'PIECHART'){
			if (thisAlert.d){
				var p211 = trudgeDown(screenPath, thisAlert, 'd', itemType, info, currentList, chains, changeTab);
				toAdd = toAdd.concat(p211);
			}
		}
	}
	if (itemType === 'placeholder' || itemType === 'elementUploadChecks' || itemType === 'elementDownloadMods' || itemType === 'scUsage' || itemType === 'selectNew' || itemType === 'amendNew'){
		if (thisAlert.s){
			var p4 = goThroughStyles(screenPath, screenPath, thisAlert, type, itemType, info, currentList);
			toAdd = toAdd.concat(p4);
		}
	}
	if (thisAlert.x){

		if (itemType === 'selectNew' || itemType === 'amendNew'){
			if (thisAlert.t === 'DIV' || thisAlert.t === 'SUMMARYDIV'){
				if (thisAlert.x.length > 0){
					if (thisAlert.s && thisAlert.s.tags){
						var tags = thisAlert.s.tags;
						var newX = [];
						var gotChanges = false;
						if (tags.color){
							var vv1 = 'color_' + tags.color;
							if (itemType === 'selectNew'){
								toAdd.push({t:vv1, s:'color'})
							}
							var vv2 = info[vv1];
							if (vv2){
								if (vv2.color){
									thisAlert.x.forEach((aX, index)=>{
										if (aX.t === 'tb'){
											aX.s.C = vv2.color.v;
											gotChanges = true;
										}
									})
								}
							}

						}
						if (itemType === 'amendNew' && gotChanges){
							toAdd.push({t:'w', w:screenPath, n:thisAlert})
						}

					}

					// replTags.forEach((vv1, index)=>{
					// 	if (vv1.indexOf('rawText_') === 0){
					// 		if (itemType === 'selectNew'){
					// 			toAdd.push({t:vv1, s:'rawText'})
					// 		}

					// 		var vv = info[vv1];
					// 		if (vv){
					// 			if (vv.rawText || vv.rawText === ''){
					// 				if (thisAlert.x[0].t === 'tb'){
					// 					var vv15 = vv.rawText;
					// 					var v1 = [];
					// 					for (var i51 = 0; i51 < vv15.length; i51++){
					// 						v1.push({u:vv15.substr(i51, 1)});
					// 					}
					// 					newX.push({t:'tb', s:thisAlert.x[0].s, v:v1});
					// 					newX.push({t:'br'});
					// 					thisAlert.x = newX;					
					// 					gotChanges = true;
					// 				}
					// 			}
					// 		}
					// 	}
					// 	if (vv1.indexOf('color_') === 0){
					// 		if (itemType === 'selectNew'){
					// 			toAdd.push({t:vv1, s:'color'})
					// 		}
					// 		var vv2 = info[vv1];
					// 		if (vv2){
					// 			if (vv2.color){
					// 				thisAlert.x.forEach((aX, index)=>{
					// 					if (aX.t === 'tb'){
					// 						aX.s.C = vv2.color.v;
					// 						gotChanges = true;
					// 					}
					// 				})
					// 			}
					// 		}
					// 	}
					// })
					// if (itemType === 'amendNew' && gotChanges){
					// 	toAdd.push({t:'w', w:screenPath, n:thisAlert})
					// }

				}
			}			
		}


		for (var i = 0; i < thisAlert.x.length; i++){
			var anI = thisAlert.x[i];
			if (anI.t === 'a' && anI.n === 'SPAN'){
				var richItem;
				try{
					richItem = CoreFns.goDownPath(currentList, ['as', anI.i]);
				}catch(err){
					console.log(err);
					console.log(err);
				}

				if (richItem){
					var p5 = goThroughStyles(['as', anI.i], screenPath, richItem, 'asset', itemType, info, currentList);
					toAdd = toAdd.concat(p5);
					if (richItem){
						var p3 = searchThroughOCSet(richItem.oc, ['as', anI.i], 'asset', screenPath, itemType, info, currentList, chains, changeTab);
						toAdd = toAdd.concat(p3);
					}

				}

			}
		}
	}	


	return toAdd;
}

function goThroughStyles(originPath, screenPath, thisAlert, type, itemType, info, currentList){
	var objType;
	if (type === 'alert'){
		objType = 'alert';
	}else if (type === 'asset'){
		objType = 'SPAN'
	}else if (type === 'item'){
		objType = thisAlert.t;
	}else if (type === 'screen'){
		objType = 'PANEL';
	}else if (type === 'NAV'){
		objType = 'NAV';
	}else if (type === 'overall'){
		objType = 'DAPP';
	}else if (type === 'LINEDATA'){
		objType = 'LINEDATA';
	}
	var styles = thisAlert.s;
  var path = []; //to change?
  var styleKeys = StyleFunctions.getPotentials(objType, styles, path, currentList);

	var toAdd = [];
	if (itemType === 'placeholder' || itemType === 'scUsage' || itemType === 'elementUploadChecks' || itemType === 'elementDownloadMods'){
	    styleKeys.forEach((aStyleKey, index)=>{
	    	if (styles[aStyleKey] && styles[aStyleKey].t === 'formula'){
				var path = originPath.concat(['s', aStyleKey])
	    		var p = formulaIsItem(styles[aStyleKey], itemType, info, path, currentList);
	    		if (p.length > 0){
	    			if (itemType === 'placeholder'){
		    			var set = {originPath, originType:type, screenPath, ocType:'lookingForPlaceholderValues'};
						toAdd.push({path, n:'Placeholder used', originSet:set});	    				
	    			}else if (itemType === 'scUsage' || itemType === 'elementUploadChecks' || itemType === 'elementDownloadMods'){
	    				toAdd = toAdd.concat(p);
	    			}
	    		}
	    	}
	    })		
	}else if (itemType === 'selectNew' || itemType === 'amendNew'){
		if (objType === 'PANEL' || objType === 'HFLEX' || objType === 'CONTAINER' || objType === 'INPUT'){
			styleKeys.push('backgroundColor');
			styleKeys.push('backgroundColor2');
		}else if (objType === 'BUTTON'){
			styleKeys.push('backgroundColor');
			styleKeys.push('hoverColor');
		}
		if (styles && styles.tags){
			styleKeys.forEach((aStyleKey, index)=>{
				if (styles.tags[aStyleKey]){
					var aTag = aStyleKey+'_'+styles.tags[aStyleKey]

					if (itemType === 'selectNew'){
						toAdd.push({t:aTag, s:aStyleKey})
					}

					var vv = info[aTag];
					if (vv && vv[aStyleKey]){
						styles[aStyleKey] = vv[aStyleKey];
						if (itemType === 'amendNew'){
							toAdd.push({t:'w', w:originPath.concat(['s', aStyleKey]), n:vv[aStyleKey]})
						}
					}
				}
			})								
		}
	}
    return toAdd;

}


function nameThePath(currentList, originSet){

	if (originSet.originType === 'overall'){
		return {name:'When dApp is loaded', a:'overall'};
	}else if (originSet.originType === 'alert' || originSet.originType === 'item' || originSet.originType === 'asset' || originSet.originType === 'screen'){
		if (originSet.ocType === 'lookingForPlaceholderValues'){
			return {name:'Irrelevant', a:originSet.originType};
		}else{
			var title = DesignerFunctions.getItemTitle(currentList, originSet.originPath, originSet.originType);
			if (originSet.ocType === 'click'){
				return {name:'When ' + title + ' is clicked', a:originSet.originType};
			}else if (originSet.ocType === 'change'){
				return {name:'When ' + title + ' is changed', a:originSet.originType};
			}

		}

	}
}

function searchThroughOCSet(ocSet, originPath, originType, screenPath, itemType, info, currentList, chains, changeTab){
	var toAdd = [];
	if (ocSet){
		var ocKeys = Object.keys(ocSet);
		ocKeys.forEach((anOCKey, index)=>{
			var p = searchThroughAnOc(ocSet[anOCKey], {originPath, originType, ocType:anOCKey, screenPath}, originPath.concat(['oc', anOCKey]), itemType, info, currentList, 0, chains, changeTab);
			toAdd = toAdd.concat(p);
		})		
	}
	return toAdd;
}

function searchThroughAnOc(oc, originSet, path, itemType, info, currentList, depth, chains, changeTab){
	var p = [];
	if (itemType === 'elementUploadChecks'){
		if (oc.t === 'toggleBannerVisibility' || oc.t === 'updateVar'){ 
			p.push({path, n:oc.t + ' function not allowed for uploads', originSet});
		}else if (oc.t.indexOf('changeInputValue') === 0){ 
			var beyond = oc.t.substr(16);
			var beyondPieces = beyond.split(' ');
			if (beyond.indexOf(info.startItemPath.join(' ')) === 0){
				var newV = ['toReplace'];
				for (var i = info.startItemPath.length + 1; i < beyondPieces.length; i++){
					newV.push(beyondPieces[i]);
				}
				oc.t = 'changeInputValue' + newV.join(' ');
			}else{
				p.push({n:'Input that is outside of uploaded set used'});
			}
			// p.push({path, n:oc.t + ' function not allowed for uploads', originSet});
		}else if (oc.t === 'changeScreen'){
			var potentials = formulaIsItem(oc.v, 'placeholder', info, path, currentList);
			var isPageHolderPageFn = false;
			for (var i5 = 0; i5 < potentials.length; i5++){
				if (potentials[i5].n === '_placeholderPage'){
					isPageHolderPageFn = true;
					break;
				}
			}
			if (!isPageHolderPageFn){
				p.push({path, n:oc.t + ' function not allowed for uploads', originSet});				
			}
		}
	}

	if (itemType === 'elementDownloadMods'){
		if (oc.t.indexOf('changeInputValue') === 0){
			var newV1 = info.startItemPath.join(' ').split(' ');
			var beyondPieces1 = oc.t.substr(16).split(' ');
			if (beyondPieces1[0] === 'toReplace'){
				for (var i51 = 1; i51 < beyondPieces1.length; i51++){
					newV1.push(beyondPieces1[i51]);
				}
				oc.t = 'changeInputValue' + newV1.join(' ');
			}
		}

	}

	if (itemType === 'scUsage'){
		if (oc.t.indexOf('existingContractFn') === 0){
			p.push({t:oc, n:'existingContractFn'});
		}else if (oc.t.indexOf('changeInputValue') === 0){
			p.push({path,t:oc, n:'changeInputValue'});
		}
	}

	if (oc.t === 'toggleBannerVisibility' && itemType === 'alert'){
		if (formulaIsItem(oc.alert, itemType, info, path, currentList).length > 0){
			p.push({path, n:'banner visibility is changed', originSet});
		}
	}else if ((oc.t.indexOf('changeInputValue') === 0) && itemType === 'INPUT'){
		var beyond5 = oc.t.substr(16);
		if (info.join(' ') === beyond5){
			p.push({path, n:'value of input is changed', originSet});
		}
	// }else if (oc.t === 'writeToDatabase' && itemType === 'databaseWrite'){
	// 	p.push({path, n:'database written', originSet});
	}else if (oc.t === 'placeholder' && itemType === 'placeholder'){
		p.push({path, n:oc.prompt, originSet});
	}else if (oc.t === 'changeScreen' && itemType === 'placeholder'){
		if (formulaIsItem(oc.v, itemType, info, path, currentList).length > 0){
			p.push({path, n:'Placeholder page used', originSet});
		}
	}else{
	}



	var pp = ResponsiveFns.getQuestionsOfACurrentAnswer(currentList, originSet.screenPath, oc, chains, changeTab);
	if (pp){

		if (itemType === 'placeholder' && oc.t.indexOf('existingContractFn ') === 0){
	      var parts = oc.t.split(' ');
	        if (!ResponsiveFns.checkThatSmartContractExists(currentList, parts[1])){
				p.push({path,t:oc, n:'Missing contract function ' + parts[2], originSet});
				pp = [{q:'If Fail', t:{t:'Action'}, i:'If_Fail', c:[]}, {q:'If Succeed', t:{t:'Action'}, i:'If_Succeed', c:[]}];
	        }
		}

		pp.forEach((aP, index)=>{
			if (oc[aP.i]){
				var thisP = path.concat([aP.i]);
				if (aP.t.t === 'Action'){
					var p1 = searchThroughAnOc(oc[aP.i], originSet, thisP, itemType, info, currentList, depth + 1, chains, changeTab);
					p = p.concat(p1);
				}else if (itemType === 'placeholder' && oc.t !== 'placeholder'){
					var isThere = formulaIsItem(oc[aP.i], itemType, info, thisP, currentList);
					if (isThere.length > 0){
						p.push({path:path.concat([aP.i]), n:'Placeholder used', originSet});
					}
				}else if (itemType === 'scUsage'){
					var isThere1 = formulaIsItem(oc[aP.i], itemType, info, thisP, currentList);
					p = p.concat(isThere1);
				}

			}
		})

	}

	return p;
}

function formulaIsItem(formulaRef, itemType, info, path, currentList){
	if (!formulaRef){
		return [];
	}else if (formulaRef.t === 'formula'){
		var a = marchDownFormulaO(formulaRef.o, path, itemType, info);
		if (itemType === 'scUsage' || itemType === 'placeholder' || itemType === 'elementUploadChecks' || itemType === 'elementDownloadMods'){
			var b = marchDownFormulaXY(formulaRef.x, formulaRef.y, path, [], itemType, info, currentList);
			return a.concat(b);
		}else{
			return a;
		}
	}else{
		return [];
	}
}

function marchDownFormulaXY(x, y, path, loc, itemType, info, currentList){
	var a = [];
	if (x.length > 0){
		var firstItem = x[0];
		if (firstItem.t === 'eS'){
			if (itemType === 'placeholder'){
	 	    	if (!ResponsiveFns.getToRelevantAbi(firstItem, currentList)){
					a.push({t:firstItem, loc, n:'formulaES'});
				}
			}else if (itemType === 'scUsage'){
				a.push({n:'formulaES', t:firstItem, loc});
			}
		}else if (firstItem.t === 'inP'){
			if (itemType === 'scUsage'){
				a.push({n:'formulaINP', t:firstItem, path, loc})
			}else if (itemType === 'elementUploadChecks'){
				inpUploadActions(firstItem, info, a);
			}else if (itemType === 'elementDownloadMods'){
				inpDownloadModActions(firstItem, info);
			}
		}else if (firstItem.t === 'gV'){
			if (itemType === 'scUsage'){
				a.push({n:'formulaGV', t:firstItem, path, loc})
			}
		}else if (firstItem.t === 'scr' && firstItem.v === '_placeholderPage' && itemType === 'placeholder'){
			a.push({n:'_placeholderPage', t:firstItem, path, loc})
		}
		if (firstItem.t === 'f' || firstItem.t === 'eS' || CoreFns.withP(firstItem.t)){
			try{
				for (var i = 1; i < x.length; i++){
					var thisY = x[i].v;
					var p = marchDownFormulaXY(y[thisY].x, y, path, ['y', thisY], itemType, info, currentList);
					a = a.concat(p);

				}				
			}catch(err){

			}
		}else if (CoreFns.justDirectFormulaNoSubsequent(firstItem.t)){
		}else if (firstItem.t === 'gV' || firstItem.t === 'eV'){
		}
	}	
	return a;
}

function inpUploadActions(o, info, toPush){
	if (o.v.join(' ').indexOf(info.startItemPath.join(' ')) === 0){
		var newV = ['toReplace'];
		for (var i = info.startItemPath.length + 1; i < o.v.length; i++){
			newV.push(o.v[i]);
		}
		o.v = newV;
	}else{
		toPush.push({n:'Input that is outside of uploaded set used'});
	}
}

function inpDownloadModActions(o, info){
	var newV = info.startItemPath.join(' ').split(' ');
	if (o.v[0] === 'toReplace'){
		for (var i = 1; i < o.v.length; i++){
			newV.push(o.v[i]);
		}
		o.v = newV;
	}
}

function marchDownFormulaO(o, path, itemType, info){

	var toPush =  [];
	if (itemType === 'scUsage' && o.t === 'eS'){
		toPush.push({n:'eS', t:o});
	}else if (itemType === 'scUsage' && o.t === 'eV'){
		toPush.push({n:'eV', t:o});
	}else if (o.t === 'al' && itemType === 'alert'){
		if (info.join(' ') === o.v.join(' ')){
			toPush.push(o);
		};
	}else if (o.t === 'pl' && itemType === 'placeholder'){
		toPush.push(o);
	}else if (o.t === 'inP' && itemType === 'elementUploadChecks'){
		inpUploadActions(o, info, toPush)
	}else if (o.t === 'inP' && itemType === 'elementDownloadMods'){
		inpDownloadModActions(o, info);
	}else if (itemType === 'scUsage' && o.t === 'inP'){
		toPush.push({n:'inP', t:o, path});
	}else if (itemType === 'scUsage' && o.t === 'gV'){
		toPush.push({n:'gV', t:o, path});
	}else if (itemType === 'placeholder' && o.t === 'scr' && o.v === '_placeholderPage'){
		toPush.push({n:'scr', t:o, path});
	}

	if (o.t === 'f' || o.t === 'eS'){
		for (var i = 0; i < o.v.length; i++){
			var pp = marchDownFormulaO(o.v[i], path, itemType, info);
			toPush = toPush.concat(pp);
		}
	}else if (CoreFns.justDirectFormulaNoSubsequent(o.t)){
	}else if (o.t === 'gV' || o.t === 'm' || o.t === 'inP' || o.t === 'eV' || o.t === 'pl' || o.t === 'pa' || o.t === 'oVar' || o.t === 'aC' || o.t === 'al'){
	}else{
		console.warn(o);
	}
	if (CoreFns.withP(o.t)){
		for (var i1 = 0; i1 < o.p.length; i1++){
			var pp1 = marchDownFormulaO(o.p[i1], path, itemType, info);
			toPush = toPush.concat(pp1);
		}

	}
	return toPush;


}